import { useState } from "react";
import { Sparkles, Gamepad2, BarChart2, Flame } from "lucide-react";
import { C } from '../constants';
import { getRank } from '../utils/helpers';
import RankIcon from './RankIcon';

export default function UserBadge({ user, onLogout, onLogin }) {
  const [open, setOpen] = useState(false);
  if (!user) {
    return (
      <button onClick={onLogin} style={{ fontFamily:"'Space Mono',monospace", fontSize:11, fontWeight:700, padding:"0 16px", height:34, borderRadius:3, background:"transparent", border:"1px solid rgba(201,168,76,0.3)", color:"rgba(201,168,76,0.7)", cursor:"pointer", letterSpacing:".1em", textTransform:"uppercase", marginLeft:10, flexShrink:0 }}>
        Sign In
      </button>
    );
  }
  const rank = getRank(user.points || 0);
  return (
    <div style={{ position:"relative" }}>
      <button onClick={()=>setOpen(o=>!o)} style={{ display:"flex", alignItems:"center", gap:8, padding:"0 12px", height:34, background:"rgba(201,168,76,0.07)", border:"1px solid rgba(201,168,76,0.2)", borderRadius:3, cursor:"pointer", color:C.text, marginLeft:10, flexShrink:0 }}>
        <RankIcon iconKey={rank.iconKey} color={rank.color} size={14}/>
        <div style={{ textAlign:"left" }}>
          <div style={{ fontSize:11, fontWeight:800, color:rank.color, lineHeight:1 }}>{user.points || 0} pts</div>
          <div style={{ fontSize:11, color:C.hint, letterSpacing:".05em" }}>{rank.name}</div>
        </div>
      </button>
      {open && (
        <div style={{ position:"absolute", right:0, top:"calc(100% + 8px)", background:"#111", border:"1px solid rgba(201,168,76,0.2)", borderRadius:14, padding:"18px 20px", minWidth:240, zIndex:200, boxShadow:"0 8px 40px rgba(0,0,0,0.8)" }} onClick={e=>e.stopPropagation()}>
          <div style={{ fontSize:11, color:C.hint, marginBottom:4, wordBreak:"break-all" }}>{user.email}</div>
          <div style={{ display:"flex", alignItems:"baseline", gap:6, marginBottom:16 }}>
            <span style={{ display:"flex", alignItems:"center", gap:8, fontSize:28, fontWeight:900, color:rank.color }}><RankIcon iconKey={rank.iconKey} color={rank.color} size={22}/> {user.points || 0}</span>
            <span style={{ fontSize:11, color:C.hint }}>pts total</span>
          </div>
          {/* Progress bar to next rank */}
          {rank.next && (
            <div style={{ marginBottom:16 }}>
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:10, color:C.hint, marginBottom:5 }}>
                <span>{rank.name}</span><span>{rank.next.name} ({rank.ptsToNext} pts away)</span>
              </div>
              <div style={{ height:5, background:"rgba(255,255,255,0.07)", borderRadius:3, overflow:"hidden" }}>
                <div style={{ height:"100%", width:`${rank.progress}%`, background:`linear-gradient(90deg,${rank.color},${rank.next.color})`, borderRadius:3, transition:"width .6s ease" }}/>
              </div>
            </div>
          )}
          {rank.progress === 100 && <div style={{ display:"flex", alignItems:"center", gap:5, fontSize:12, color:"#FF6B35", fontWeight:700, marginBottom:16 }}><Sparkles size={12} strokeWidth={2}/> Max rank achieved!</div>}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:16 }}>
            {[[<Gamepad2 size={16} strokeWidth={1.5} color="#60A5FA"/>,"Game",user.gamePoints||0],[<BarChart2 size={16} strokeWidth={1.5} color="#e8c875"/>,"Analysis",user.analysisPoints||0],[<Flame size={16} strokeWidth={1.5} color="#FF6B35"/>,"Streak",user.loginStreak||1]].map(([ico,lbl,val])=>(
              <div key={lbl} style={{ background:"rgba(255,255,255,0.04)", borderRadius:10, padding:"8px 6px", textAlign:"center" }}>
                <div style={{ display:"flex", justifyContent:"center", marginBottom:2 }}>{ico}</div>
                <div style={{ fontSize:13, fontWeight:800, color:C.text }}>{val}</div>
                <div style={{ fontSize:11, color:C.hint }}>{lbl}</div>
              </div>
            ))}
          </div>
          <button onClick={()=>{ onLogout(); setOpen(false); }} style={{ width:"100%", padding:"8px", background:"rgba(255,59,48,0.08)", border:"1px solid rgba(255,59,48,0.2)", borderRadius:8, color:C.neg, fontSize:12, fontWeight:700, cursor:"pointer" }}>Sign Out</button>
        </div>
      )}
    </div>
  );
}
